<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<mask
		id="mask-twitter-0"
		mask-type="alpha"
		maskUnits="userSpaceOnUse"
		x="2"
		y="4"
		width="21"
		height="17"
	>
		<path
			d="M23 5.99739C22.242 6.35248 21.3949 6.57441 20.5478 6.66319C21.4395 6.13055 22.1083 5.28721 22.4204 4.3107C21.5732 4.79896 20.6815 5.15405 19.7006 5.33159C18.8981 4.48825 17.7834 4 16.5796 4C13.8153 4 11.7643 6.57441 12.3885 9.2376C8.77707 9.06005 5.61146 7.37337 3.51592 4.79896C2.40127 6.70757 2.93631 9.2376 4.8535 10.5248C4.14013 10.4804 3.47134 10.3029 2.89172 9.99217C2.84713 11.9896 4.27389 13.8094 6.32484 14.2533C5.70064 14.4308 5.07643 14.4752 4.36306 14.342C4.89809 16.0287 6.50318 17.2715 8.3758 17.3159C6.54777 18.7363 4.27389 19.3577 2 19.0914C3.9172 20.2898 6.1465 21 8.59873 21C16.5796 21 21.0828 14.2976 20.8153 8.2611C21.707 7.63969 22.4204 6.88512 23 5.99739Z"
			fill="white"
		/>
	</mask>
	<g mask="url(#mask-twitter-0)">
		<rect width="24" height="24" fill="currentColor" />
	</g>
</svg>
